import HeaderItem from '../../Components/HeaderItem/HeaderItem';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';
import HeaderLogo from '../../Components/HeaderLogo/HeaderLogo';
import classes from './Header.module.css';
import {useState, useEffect} from 'react';
import './partial.css';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/Nav';
import {Link} from 'react-router-dom';

const Header = ({links}) => {
	const [scrolled, setScrolled] = useState(false);

	const items = ['search', 'email', 'phone'];
	const settings = {
		color: 'white',
		width: '16px',
		height: '16px'
	};

	const [bar, setBar] = useState(false);
	const [swiped, setSwipe] = useState(false);

	const swipe = display => {
		if (swiped !== display) {
			setSwipe(display);
		}
	};

	const navItems = Object.entries(links).reduce((curr, [text, link]) => {
		const valids = ['Inicio', 'Nosotros', 'Contacto'];
		if (valids.includes(text)) {
			curr[text] = link;
		}
		return curr;
	}, {});

	const dropdowns = Object.entries(links).reduce((curr, [text, link]) => {
		const invalids = ['Inicio',
		 		 'Nosotros',
		 		 'Contacto',
		 		 'Hablamos',];
		if (!invalids.includes(text)) {
			curr[text] = link;
		}
		return curr;
	}, {});

	const [mobileNavItems, setMobileNavItems] = useState(
		Object.entries(links).reduce((curr, [text]) => ({
							 	...curr,
							 	[text]:false
							 }), {}))

	const interactSingleNav = (display, item) => {
		if (mobileNavItems[item] !== display) {
			let change = {...mobileNavItems};
		    change = Object.entries(change).reduce((curr, [k, v]) => {
		    	return {
		    		...curr,
		    		[k]: false
		    	}
		    }, {});
		    change[item] = display;
		    setMobileNavItems(change);
		}
  	}

  	const capitalizeFirstLetter = string => {
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

	const menuDrop = Object.entries(dropdowns).reduce((curr, [text, link]) => {
		let data = [[], []];
		if (text==='Servicios') {
			data[0] = [text, link];
			Object.entries(dropdowns).forEach(([dropdownText, dropdownLink]) => {
	 			if (dropdownText!=='Servicios') {
	 				data[1] = [...data[1], [dropdownText, dropdownLink]];
	 			}
	 		})
		}
		if (data[0].length && data[1].length) {
			curr.push(data);
		}
		return curr;
	}, []);

	window.addEventListener("scroll", () => {
		if (window.scrollY > 370 && !scrolled) {
			setScrolled(true);
		}

		if (window.scrollY < 370 && scrolled ) {
			setScrolled(false);
		}
	});
	useEffect(() => {
		if (window.scrollY > 370 && !scrolled) {
			setScrolled(true);
		}

		if (window.scrollY < 370 && scrolled ) {
			setScrolled(false);
		}
	}, []);

	return (
		<nav className={`${classes.container} ${scrolled ? classes.activeContainer : ""} ${swiped ? 'headerMobile' : ''}`}>
			<div className={classes.logoContainer}>
				<HeaderLogo classCss={`${classes.headerLogo} `}/>
			</div>
			<Navbar expand={"lg"}
					className={classes.navBarSearchContact}
					onToggle={(expand)=>{swipe(expand)}}>
				<Container>
					<Navbar.Toggle
					aria-controls="basic-navbar-nav"
					className={`${swiped ? 'open-icon-middle' : ''}`}
					onClick={() => {swipe(true)}}/>
					<Navbar.Collapse id="basic-navbar-nav">
				      <div className={`${classes.searchContact} hide`}>
							<HeaderNavigation barClass={bar ? 'showSearchBar' : ''}
									  dropdowns={menuDrop}
									  items={Object.entries(navItems)}
									  closeEvent={()=>{setBar(false)}}/>
							<div className={classes.contactSection}>
								{
									items.map((type, index) => <HeaderItem icon={type}
																		   containerCss={classes.item}
																		   iconSettings={settings}
																		   e={
																		   	type==='search'?
																		   	()=>{setBar(true)}:
																		   	()=>{}
																		   }
																		   key={index}/>)
								}
							</div>
					   </div>
				    </Navbar.Collapse>
				</Container>
			</Navbar>
			<SwipeableDrawer anchor={'left'}
							 open={swiped}
							 swipeAreaWidth={40}
							 onOpen={()=>{swipe(true)}}
							 onClose={()=>{swipe(false)}}>
				<div className={classes.drawerContent}>
					<div className={classes.mobileNavSection}>
						{
							Object.entries(navItems).map(([text, link], index) =>
								<div>
									<Link to={link}>{capitalizeFirstLetter(text)}</Link>
								</div>
								)
						}
						{
							Object.entries(dropdowns).map(([text, link], index ) => {
								if (text==='Servicios') {
									const toUse = text.toLowerCase();
									const navHeader = <>
										<p>{capitalizeFirstLetter(toUse)}</p>
										<ExpandMoreIcon onClick={()=>{
												  if (mobileNavItems[toUse]) {
						                              interactSingleNav(false, toUse)
												  } else {
					                              	  interactSingleNav(true, toUse)
												  }
					                            }} sx={{
					                            	transform: mobileNavItems[toUse] ? 'rotateZ(180deg)' : ''
					                            }}/>
										</>
									return <div key={index} className={`${mobileNavItems[toUse] ? 'showMobileSubContainer' : ''}`}>
										{
											mobileNavItems[toUse] ? <div>{navHeader}</div> : navHeader
										}
					                    <div className={`${classes.mobileNavSub} ${mobileNavItems[toUse] ? 'showSub' : ''}`}>
				                         	{
				                         		Object.entries(dropdowns).map(([dropdownText, dropdownLink], dropdownIndex) => {
				                         			if (dropdownText!=='Servicios') {
				                         				return <Link key={dropdownIndex} to={dropdownLink}>{capitalizeFirstLetter(dropdownText)}</Link>
				                         			} else {
				                         				return null;
				                         			}
				                         		})
				                         	}
				                        </div>
									</div>
								} else {
									return null
								}
							})
						}
					</div>
					<div className={classes.drawerContent__bottom}>
						<a href={"#"}>Hablamos?</a>
					</div>
				</div>
			</SwipeableDrawer>
		</nav>
	);
};

export default Header;
